import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../hooks/useAdminAuth";
import { LoadingScreen } from "../common/LoadingScreen";
import { AdminRole } from "../../services/admin/admin.service";
import { getLoginPathForRole } from "../../contexts/AdminAuthContext/context";
import { useEffect, useRef } from "react";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: AdminRole[];
  loginPath: string;
}

export function AdminProtectedRoute({
  children,
  allowedRoles,
  loginPath,
}: AdminProtectedRouteProps) {
  const { isAuthenticated, isLoading, user, logout } = useAdminAuth();
  const hasLoggedOut = useRef(false);

  const userRole = user?.role;
  const roleMismatch = isAuthenticated && userRole && !allowedRoles.includes(userRole);

  useEffect(() => {
    if (roleMismatch && !hasLoggedOut.current) {
      hasLoggedOut.current = true;
      logout();
    }
  }, [roleMismatch, logout]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={loginPath} replace />;
  }

  if (roleMismatch) {
    const redirectPath = userRole ? getLoginPathForRole(userRole) : loginPath;
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}
